import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { Option } from '@telespot/protocols/data-access';

@Component({
    selector: 'ts-protocol-cell',
    templateUrl: './protocol-cell.component.html',
    styleUrls: ['./protocol-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProtocolCellComponent {
  @Input() label: Option;
  @Input() collapsed: boolean;
  @HostBinding('class.protocol-cell--collapsed') get isCollapsed(): boolean {
    return this.collapsed === true;
  }
  @Input() count: number;
  @Input() displayCount: number | undefined;
  @Input() total: number;
  @Input() connectedDropLists: string[];
  @Input() changeCount = 0;
  @Input() loading = true;
  @Input() excludedFromCounter: boolean;
  @Input() excludeable = false;
  @Input() hidePercentage = false;

  @Output() cropsLabelAdded = new EventEmitter<string>();
  @Output() excludeFromCounter = new EventEmitter<void>();
  @Output() selectLabel = new EventEmitter<void>();
  @Output() contextMenuRequested = new EventEmitter<MouseEvent>();

  public readonly tooltipDelay = 1000;

  public get percentageValue() {
    return this.counterValue > 0 ? (this.counterValue / this.total) * 100 : 0;
  }

  public get counterValue() {
    return this.excludedFromCounter ? 0 : this.count;
  }

  /** Valor a mostrar en el count: cuando está excluido, el displayCount (valor real) si existe; si no, count */
  public get countDisplayValue(): number {
    if (this.excludedFromCounter && this.displayCount !== undefined && this.displayCount !== null) {
      return this.displayCount;
    }
    return this.count;
  }

  public get percentageDisplay(): string {
    if (this.excludedFromCounter) return '--%';
    return this.percentageValue > 0 ? this.percentageValue.toFixed(1) + '%' : '0%';
  }

  public onContextMenu(event: MouseEvent): void {
    event.preventDefault();
    this.contextMenuRequested.emit(event);
  }
}
